import http from '../utils/http'

export function requestIndexDetail (params) {
  return http.get('/timeSeries/requestIndexDetail', params)
}

export function updateStrategyName (params) {
  return http.post('/strategy-tagInfo/update', params)
}

export function postTickersWithTags (params) {
  return http.get('/ticker/requestAllNames', params)
}

// 通用接口
export function getTimeSeriesRequest (requestName, params) {
  return http.get('/timeSeries/' + requestName, params)
}

export function postTimeSeriesRequest (requestName, params) {
  return http.post('/timeSeries/' + requestName, params)
}

// 通用接口
export function getUserCategory (requestName, params) {
  return http.get('/userCategory/' + requestName, params)
}

export function postUserCategory (requestName, params) {
  return http.post('/userCategory/' + requestName, params)
}

export function postAdminCategory (requestName, params) {
  return http.post('/adminCategory/' + requestName, params)
}



// WEBPACK FOOTER //
// ./src/api/timeSeries.js